<template>
  <el-upload
    class="input imagen"
    :action="''"
    :auto-upload="false"
    :on-change="onSelectFile"
    :before-upload="iniciandoCarga"
    :on-success="finalizandoCarga"
    :accept="accept"
    :show-file-list="false"
    :file-list="fileList"
    :list-type="showPreview ? 'picture': undefined"
    :disabled="limit === fileList.length"
    :multiple="multiple"
  >
  <el-button v-if="withBtn" size="small" :disabled="limit === fileList.length">{{ $t(this.labelTag) }}</el-button>
    <div v-else class="label">{{ $t(this.labelTag) }}</div>
    
    <div slot="tip" class="el-upload__tip">
      <div class="fileContainer">
        <div v-for="(item, index) in fileList" :key="index" class="file">
          
          <i v-bind:class="`status-icon ${getItemIcon(item)}`"></i>
          <span v-bind:class="item.error ? 'error' : ''">{{ item.name }}</span>
          
          <span class="delete" @click="onRemoveFile(index)"><i class="el-icon-close"></i></span>
          <img v-if="showPreviewAux === true" :src="item.url" @click="onImageClick(item)" style="margin-top: 6px; display: block" width="100">
        </div>
      </div>
    </div>
  </el-upload>
</template>

<script>
import { garantia } from '../../apiClient';
  import { showError } from '../Mensaje'
  import { mostrarMensajeInternacionalizado } from "../MensajeInternacionalizado/index";

  export default {
    name: 'FileUpload',
    props: {
      name: { PropType: String, default: 'uploadInput' },
      labelTag: { PropType: String, default: 'FILE_UPLOAD_cargar_imagen' },
      files: { PropType: Array, default: [] },
      storeAction: String,
      temporalId: String,
      numeroArchivo: Number,
      onFileListChange: Function,
      cargandoArchivo: Function,
      onFileNameChange: Function,
      accept: { PropType: String, default: '*' },
      withBtn: { PropType: Boolean, default: true },
      showPreview: { PropType: Boolean, default: false },
      limit: { PropType: Number, default: undefined },
      multiple: { PropType: Boolean, default: false },
      foro: { PropType: Boolean, default: false },
      garantia: { PropType: Boolean, default: false },
    },
    data() {
      return {
        fileList: this.inicializarLista(),
        showPreviewAux: this.showPreview,
        fileExtension: undefined,
        arch: ""
      }
    },
    watch: {
      files(newValue, oldValue) {
        this.fileList = this.inicializarLista()
      },
    },
    methods: {
      inicializarLista() {
        return this.files.map((x) => { 
          return {
            name: x.name,
            url: x.url,
            uploading: false,
            error: false
          } 
        })
      },
      onSelectFile(file) {
        // verifico si se superó el máximo de archivos permitidos
        if(this.limit !== undefined && this.limit <= this.fileList.length)
        {
          showError(this.$t('FILE_UPLOAD_limite_exedido'))
          return
        }        
        // verifico que la extension pertenezca a las permitidas
        let valido = false;
        if(this.accept !== "*")
        {
          // armo el array con las extensiones permitidas pasadas en la propiedad 'accept'
          let extensiones = this.accept.split(',.');
          // obtengo la extension del archivo que se quiere subir
          //this.file_extension = 
          var file_extension = file.name.split('.').pop().toLowerCase();
          this.fileExtension = file_extension;
          
          if (this.garantia) {
            // let num = numeroArchivo;
             this.arch = file.name.split('.')[0]
          }

          // verifico que la extension del archivo que se quiere subir pertenezca a las extensiones permitidas
          if(extensiones.filter(x => x == file_extension).length > 0)
            valido = true;
          // Si es una imagen (png o jpg), mostramos la preview
          
          if(file_extension === 'png' || file_extension === 'jpg'){
            this.showPreviewAux = true;
          }else{ this.showPreviewAux = false; }
          
        }
        else
          valido = true
          
        // si no es valida la extension muestro un mensaje de error
        if(!valido)
        {
          showError(this.$t('FILE_UPLOAD_extension_no_permitida'));
          return
        }

        if(this.foro == true) {this.cargandoArchivo(true);}
        // creo un nuevo item de file
        let fileItem = {
          name: file.name,
          url: file.url,
          uploading: true,
          error: false
        }
        this.fileList.push(fileItem)

         let payload = {}
        
        if (this.garantia) {
           
          payload = {
          file: file.raw,
          id: this.arch,
          numeroArchivo: this.numeroArchivo
        }
        } else {
          payload = {
          file: file.raw,
          id: this.temporalId,
          numeroArchivo: this.numeroArchivo
        }
        }

        // subo el archivo
       

        this.$store.dispatch(this.storeAction, payload)
        .then(data => { 
            if(data.CodigoResultado === 0)
            {
              fileItem.uploading = false
              this.listChanged()
            }
            else 
            {
              mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)
            }
          },
          error => { fileItem.error = true }
        )
      },
      onRemoveFile(index) {
        // quito el archivo de la lista
        this.fileList.splice(index, 1)
        this.listChanged()
      },
      listChanged() {
        let fileNames = this.fileList.map((x) => {return { name: x.name, url: x.url }})
        this.onFileListChange(this.name, fileNames)
        this.cargandoArchivo(false)
      },
      getItemIcon(fileItem) {
        if(fileItem.error)
          return 'el-icon-error'
        
        else if(fileItem.uploading)
          return 'el-icon-loading'

        else
          return 'el-icon-success' 
      },
      onImageClick(fileItem) {
        window.open(fileItem.url, '_blank')
      },
      iniciandoCarga() {
        this.cargando = true;
      },
      finalizandoCarga() {
        this.cargando = false;
      }
    }
  }
</script>

<style scoped>

.fileContainer {
  margin-top: 10px;
  display: grid;
}

.file {
  margin: 2px 0px;
}

.file i.status-icon {
  margin-right: 5px;
}

.file i.el-icon-loading {
  color: var(--main-color);
}

.file i.el-icon-success
{
  color: #068806;
}

.file i.el-icon-error {
  color: #F44336;
}

.file .delete {
  float: right;
  cursor: pointer;
}
.file .delete i {
  margin: 2px;
}

.file img {
  cursor: pointer;
}

.label {
  font-size: 13px;
  color: var(--main-color);
}
</style>